interface FilterBarProps {
  categories: string[];
  activeCategories: string[];
  onCategoryToggle: (category: string) => void;
  /** Optional fixed label width so "Category:" aligns with sibling filter rows. */
  labelMinWidth?: string;
}

export default function FilterBar({ categories, activeCategories, onCategoryToggle, labelMinWidth }: FilterBarProps): JSX.Element | null {
  if (categories.length === 0) return null;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", alignItems: "center" }}>
      <span style={{ fontSize: "0.85rem", color: "#888", fontWeight: 600, minWidth: labelMinWidth }}>Category:</span>
      {categories.map((cat) => {
        const active = activeCategories.some((c) => c.toLowerCase() === cat.toLowerCase());
        return (
          <button
            key={cat}
            onClick={() => onCategoryToggle(cat)}
            style={{
              padding: "0.4rem 0.75rem",
              fontSize: "0.85rem",
              borderRadius: "9999px",
              border: active ? "2px solid #0078d4" : "1px solid #ddd",
              backgroundColor: active ? "#e6f0ff" : "white",
              color: active ? "#0078d4" : "#666",
              fontWeight: active ? 600 : 400,
              cursor: "pointer",
            }}
          >
            {cat}
          </button>
        );
      })}
    </div>
  );
}
